module.exports = __webpack_public_path__ + "static/media/dataUsesDark.7c516ba7.svg";